import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-custom-field-modal',
    templateUrl: './custom-field-modal.component.html',
    styleUrls: ['./custom-field-modal.component.scss'],
    standalone: false
})
export class CustomFieldModalComponent {
  @Input() public data: any[];
}
